import { render, staticRenderFns } from "./IncomesReportTotal.vue?vue&type=template&id=2b4caea7&scoped=true&"
import script from "./IncomesReportTotal.vue?vue&type=script&lang=js&"
export * from "./IncomesReportTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4caea7",
  null
  
)

export default component.exports